import { render, staticRenderFns } from "./summary-unit.vue?vue&type=template&id=5cf88e25&lang=pug&"
import script from "./summary-unit.vue?vue&type=script&lang=js&"
export * from "./summary-unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports